// Subcontracts Data
export const subcontractsData = {
  2024: {
    totalCost: 17.8,
    weightInOpex: 9.1,
    yoyChange: null,
    vsBudget: 4.2,
    manPower: {
      value: 11.2,
      percentage: 62.9,
      yoyChange: null,
      vsBudget: 2.8,
      badge: { pt: 'Estrutural', en: 'Structural' },
      costPerWorker: 28.5,
      contractedWorkers: 393,
    },
    sondagem: {
      value: 6.6,
      percentage: 37.1,
      yoyChange: null,
      vsBudget: 6.8,
      badge: { pt: 'Variável', en: 'Variable' },
      costPerMeter: 185,
      metersPerformed: 35680,
    },
  },
  2025: {
    totalCost: 19.5,
    weightInOpex: 10.0,
    yoyChange: 9.6,
    vsBudget: 5.2,
    manPower: {
      value: 12.4,
      percentage: 63.6,
      yoyChange: 10.7,
      vsBudget: 3.2,
      badge: { pt: 'Estrutural', en: 'Structural' },
      costPerWorker: 29.8,
      contractedWorkers: 416,
    },
    sondagem: {
      value: 7.1,
      percentage: 36.4,
      yoyChange: 7.6,
      vsBudget: 8.8,
      badge: { pt: 'Mais volátil', en: 'More volatile' },
      costPerMeter: 192,
      metersPerformed: 36980,
    },
    keyInsights: [
      {
        title: { pt: 'Concentração', en: 'Concentration' },
        headline: { pt: 'Maior concentração em Man Power', en: 'Highest concentration in Man Power' },
        detail: { pt: 'Man Power representa a principal componente da rubrica de subcontratos, condicionando a flexibilidade do custo.', en: 'Man Power represents the main component of the subcontracts category, limiting cost flexibility.' },
        badge: { pt: 'Alta relevância', en: 'High relevance' },
        badgeType: 'high',
      },
      {
        title: { pt: 'Desvio', en: 'Deviation' },
        headline: { pt: 'Sondagem com maior volatilidade', en: 'Drilling with higher volatility' },
        detail: { pt: 'Sondagem tende a apresentar maior sensibilidade a campanhas, necessidades técnicas específicas e variação do plano.', en: 'Drilling tends to show higher sensitivity to campaigns, specific technical needs and plan variations.' },
        badge: { pt: 'Ponto de atenção', en: 'Watchpoint' },
        badgeType: 'medium',
      },
      {
        title: { pt: 'Prioridade', en: 'Priority' },
        headline: { pt: 'Foco em disciplina contratual', en: 'Focus on contractual discipline' },
        detail: { pt: 'A prioridade executiva é separar custo estrutural recorrente de custo pontual, assegurando controlo de escopo, produtividade e orçamento.', en: 'The executive priority is to separate recurring structural cost from one-off cost, ensuring scope, productivity and budget control.' },
        badge: { pt: 'Prioridade de gestão', en: 'Management priority' },
        badgeType: 'priority',
      },
    ],
  },
  2026: {
    totalCost: 20.2,
    weightInOpex: 10.2,
    yoyChange: 3.6,
    vsBudget: 2.8,
    manPower: {
      value: 12.9,
      percentage: 63.9,
      yoyChange: 4.0,
      vsBudget: 1.8,
      badge: { pt: 'Estrutural', en: 'Structural' },
      costPerWorker: 30.5,
      contractedWorkers: 423,
    },
    sondagem: {
      value: 7.3,
      percentage: 36.1,
      yoyChange: 2.8,
      vsBudget: 4.5,
      badge: { pt: 'Variável', en: 'Variable' },
      costPerMeter: 198,
      metersPerformed: 36870,
    },
    keyInsights: [
      {
        title: { pt: 'Concentração', en: 'Concentration' },
        headline: { pt: 'Maior concentração em Man Power', en: 'Highest concentration in Man Power' },
        detail: { pt: 'Man Power representa a principal componente da rubrica de subcontratos, condicionando a flexibilidade do custo.', en: 'Man Power represents the main component of the subcontracts category, limiting cost flexibility.' },
        badge: { pt: 'Alta relevância', en: 'High relevance' },
        badgeType: 'high',
      },
      {
        title: { pt: 'Desvio', en: 'Deviation' },
        headline: { pt: 'Sondagem com maior volatilidade', en: 'Drilling with higher volatility' },
        detail: { pt: 'Sondagem tende a apresentar maior sensibilidade a campanhas, necessidades técnicas específicas e variação do plano.', en: 'Drilling tends to show higher sensitivity to campaigns, specific technical needs and plan variations.' },
        badge: { pt: 'Ponto de atenção', en: 'Watchpoint' },
        badgeType: 'medium',
      },
      {
        title: { pt: 'Prioridade', en: 'Priority' },
        headline: { pt: 'Foco em disciplina contratual', en: 'Focus on contractual discipline' },
        detail: { pt: 'A prioridade executiva é separar custo estrutural recorrente de custo pontual, assegurando controlo de escopo, produtividade e orçamento.', en: 'The executive priority is to separate recurring structural cost from one-off cost, ensuring scope, productivity and budget control.' },
        badge: { pt: 'Prioridade de gestão', en: 'Management priority' },
        badgeType: 'priority',
      },
    ],
  },
};
